<app-view-item
  *ngIf="disabled"
  [text]="value"
  [borderless]="borderless"
></app-view-item>

<input
  *ngIf="!disabled"
  nz-input
  [(ngModel)]="value"
  [maxLength]="maxlength"
  [placeholder]="placeholder"
  [required]="isRequired"
  (ngModelChange)="onModelChange($event)"
  (click)="onClick($event.target)"
  (keydown)="onKeyDown($event)"
/>
